export type OpportunityStageId =
  | 'Lead'
  | 'Qualified'
  | 'Proposal'
  | 'Negotiation'
  | 'Won'
  | 'Lost';

export type OpportunityStageConfig = {
  id: OpportunityStageId;
  label: string;
  headerClass: string;
  columnClass: string;
  cardAccentClass: string;
};

export const OPPORTUNITY_STAGES: OpportunityStageConfig[] = [
  {
    id: 'Lead',
    label: 'Lead',
    headerClass: 'bg-slate-700 text-white',
    columnClass: 'bg-slate-50 border-slate-200',
    cardAccentClass: 'border-l-slate-500',
  },
  {
    id: 'Qualified',
    label: 'Qualificado',
    headerClass: 'bg-sky-600 text-white',
    columnClass: 'bg-sky-50 border-sky-200',
    cardAccentClass: 'border-l-sky-500',
  },
  {
    id: 'Proposal',
    label: 'Proposta',
    headerClass: 'bg-violet-600 text-white',
    columnClass: 'bg-violet-50 border-violet-200',
    cardAccentClass: 'border-l-violet-500',
  },
  {
    id: 'Negotiation',
    label: 'Negociação',
    headerClass: 'bg-amber-600 text-white',
    columnClass: 'bg-amber-50 border-amber-200',
    cardAccentClass: 'border-l-amber-500',
  },
  {
    id: 'Won',
    label: 'Ganho',
    headerClass: 'bg-emerald-600 text-white',
    columnClass: 'bg-emerald-50 border-emerald-200',
    cardAccentClass: 'border-l-emerald-500',
  },
  {
    id: 'Lost',
    label: 'Perdido',
    headerClass: 'bg-rose-600 text-white',
    columnClass: 'bg-rose-50 border-rose-200',
    cardAccentClass: 'border-l-rose-500',
  },
];

export function getStageConfig(stage: string): OpportunityStageConfig {
  return OPPORTUNITY_STAGES.find((item) => item.id === stage) ?? OPPORTUNITY_STAGES[0];
}
